import DataTables from '../../components/dataTables.js';
import StoreSidebar from './sidebar.js';
import Content from '../../content.js';

var Index = Content.extend({
  dom: {
    CURRENT_TABLE: '.ui.tab.active table',
    IMPORT_CONTAINER: '#import-xml-file',
    IMPORT_FORM: '#import-xml-form',
    GROUP_SELECTOR: '.node-group-selector',
    IMPORT_BTN: '#import-xml-btn',
  },

  selectedGroups: [],

  /*
  PUBLIC FUNCTIONS
  */
  beforeRender: function () {
    this.tabs = [];
    this.dataTables = [];
    this.sidebar = new StoreSidebar();
  },

  onDestroy: function () {
    _.each(this.dataTables, function (dataTable) {
      dataTable.remove();
    });
    this.sidebar.destroy();

    if (this.selectCsvFieldsModal) {
      this.selectCsvFieldsModal.destroy();
    }
  },

  render: function () {
    this._lazyDrawDatatable(this._mountUrl());
    $(this.dom.IMPORT_BTN).on(
      'click',
      { dom: this.dom },
      this._showConfirmModal.bind(this),
    );

    this.$(this.dom.GROUP_SELECTOR).multipleSelect({
      selectAll: true,
      filter: true,
      width: 180,
      onCheckAll: () => {
        this.selectedGroups = [];

        $(this.dom.GROUP_SELECTOR)
          .find('option')
          .each((i, element) => {
            this.selectedGroups.push(element.value);
          });

        this._filterNodeGroups();
      },
      onUncheckAll: () => {
        this.selectedGroups = [];
        this._filterNodeGroups();
      },
      onClick: (view) => {
        if (view.checked) {
          this.selectedGroups.push(view.value);
        } else {
          this.selectedGroups.splice(
            this.selectedGroups.indexOf(view.value),
            1,
          );
        }

        this._filterNodeGroups();
      },
    });
  },
  /*
  PRIVATE FUNCTIONS
  */

  _filterNodeGroups: function () {
    this._lazyDrawDatatable(this._mountUrl());
  },

  _showConfirmModal: function (e) {
    var inputFile = $('input[type="file"]'),
      file = inputFile[inputFile.length - 1].files[0],
      hierarchyId = $('input[name="hierarchy_field_id"]')[0].value,
      warnModal,
      route;

    e.target.blur();

    if (file) {
      e.preventDefault();

      route = hierarchyId
        ? `hierarchy_template_impact?hierarchy_field_id=${hierarchyId}&filename=${file.name}`
        : `global_template_impact?filename=${file.name}`;

      warnModal = new IO.Views.Components.ConfirmationDialog({
        url: `/${currentCustomer}/${route}&import=true`,
        jst_template: 'stores/templates/impacted',
        method: 'GET',
        modalWidth: 640,
      });

      warnModal.impact();
      warnModal.answer(function (proceed) {
        if (proceed) {
          e.target.form.submit();
        }
        warnModal.destroy();
      });
    }
  },

  _isDataTableInstantiated: function ($table, tab) {
    return !($table.length && this.tabs.indexOf(tab) === -1);
  },

  _mountUrl: function () {
    var url =
      '/' +
      currentCustomer +
      '/stores.json' +
      '?groups=' +
      this.selectedGroups.join(',');

    return url;
  },

  _lazyDrawDatatable: function (url) {
    var table,
      baseStructure =
        '<table class="display dataTables ui selectable striped table stores-table"></table>',
      source =
        typeof url === 'undefined'
          ? '/' + currentCustomer + '/stores.json'
          : url;

    if (typeof this.dataTable !== 'undefined') {
      this.dataTable.destroy();
      $('.stores-table-container').html(baseStructure);
    }

    table = $('.stores-table');

    this.dataTable = new DataTables({
      serverSide: true,
      ajaxSource: source,
      el: table,
      columns: window.da_grid_columns,
      controller: 'stores',
      filter: true,
      fixed: false,
      title: 'Click to edit',
    });

    this.dataTable.start();
  },
});

module.exports = Index;
